import {Injectable} from '@angular/core';
import {BaseApiService} from "../../../shared/base/base-api.service";
import {CountriesResponse} from "./countries/countries-response";

@Injectable({
  providedIn: 'root'
})
export class CommonService extends BaseApiService {

  getCountries() {
    return this.fromFile<CountriesResponse>('assets/json/app-data/countries.json');
  }

}
